const riot = require('riot');

riot.tag2('item-message', '<div class="py8 pr16 pl8 border border-transparent hover-trigger hover-bg-background_light_secondary s-px8 {getClass()} {isChecked() ? \'border border-primary rounded-8\' :\'\'} {opts.selectmode ? \'cursor-pointer\' :\'\'}" if="{!this.opts.item.isActivity()}" ondblclick="{onAddReactionEyes}" ontouchstart="{dblTapAddReactionEyes}" onclick="{toggleCheckbox}" onmousemove="{onMousemove}" onmouseleave="{onMouseleave}" ref="comment"> <div class="f fm fbw mb6"> <div class="f fm fbw w-full"> <div class="f fm"> <div class="f fm" role="button"> <div class="f fm mr8" if="{opts.selectmode}"> <input class="flex-fixed checkbox my10 mx4" ref="checkbox" type="checkbox" onclick="{toggleCheckbox}"> </div> <div class="relative mr8"> <div data-is="item-user-icon" user="{opts.item.getUser()}"></div> <div class="absolute rn5 bn4 p1 bg-white circle tooltip" if="{opts.item.isAI()}" aria-label="AIが投稿したコメント" data-tooltip-position="top"><img class="block s14 circle" src="/images/icons/ai_badge.svg"></div> </div> <div class="fs11 lh15 bold mr5">{opts.item.getUser().data.screen_name}</div> </div> <div class="fs11 lh15 text-gray" data-is="atom-time" date="{opts.item.data.created_at}"></div> </div> <div if="{app.useragent.isMobile}" data-is="module-action-menus" ref="menu" is-edit="{isEdit}" is-mine="{isMine}"></div> </div> <div if="{opts.item.isMine()}"> <div class="relative cursor-pointer hover-trigger tooltip" if="{isEdit}" onclick="{onCancel}" role="button" aria-label="キャンセル" data-tooltip-position="top"> <p class="absolute b16 ln1 text-label_dark_medium fs12">Esc</p><i class="icon-close-circle fs18 text-label_dark_medium hover-text-background_dark_primary"></i> </div> </div> </div> <div class="{\'pl32\' : !isEdit}"> <p class="fs13 lh15 word-break-word mb4" if="{!isEdit}" data-is="atom-markdown" content="{opts.item.data.content}" onmentionclick="{onMentionClick}"></p> <div class="text-label_dark_medium fs10 mb4" if="{opts.item.isEdited() &amp;&amp; !isEdit}">(編集済)</div> <div class="bg-white border border-label_white_primary rounded-8 mb8" if="{isEdit}"> <div ref="form" data-is="module-comment-form" mentions="{mentions}" label="保存" note="{opts.note}" project="{opts.project}"></div> </div> <div if="{!isEdit}" data-is="module-message-reactions" item="{opts.item}" onsubmit="{look}"></div> </div> </div> <div if="{this.opts.item.isActivity()}"> <div class="f ft fbw py9 px16 fs11 lh20 text-gray"> <div class="word-break-all mr11"><span class="fs10 bold mr4">{opts.item.getUser().data.screen_name}</span><span class="fs11 mr4">が</span><span class="inline-children mb4" data-is="atom-markdown" content="{opts.item.data.content}"></span></div> <p class="flex-fixed fs11 lh20" data-is="atom-time" date="{opts.item.data.created_at}"></p> </div> </div>', 'item-message,[data-is="item-message"]{display:block} item-message .inline-children *,[data-is="item-message"] .inline-children *{display:inline}', '', function(opts) {
    this.overlay = null;

    this.on('update-checked', (newChecked) => {
      this.updateCheckedState(newChecked);
    });

    this.updateCheckedState = (newChecked) => {
      if (this.refs.checkbox) {
        this.refs.checkbox.checked = newChecked;
      }
      this.update();
    };

    this.mixin('enableOptsEventHandler');

    this.isEdit = false;

    this.isMine = this.opts.item.isMine();

    this.addEscCancel = () => {
      if (this._escCancelListener) return;
      this._escCancelListener = (e) => {
        const key = e.key || e.keyCode;
        const is_esc = (typeof key === 'string' && key.toLowerCase() === 'escape') || key === 27 || e.code === 'Escape';
        if (!is_esc) return;
        if (!this.isEdit) return;
        e.preventDefault();
        this.onCancel();
      };
      document.addEventListener('keydown', this._escCancelListener, true);
    };
    this.removeEscCancel = () => {
      if (this._escCancelListener) {
        document.removeEventListener('keydown', this._escCancelListener, true);
        this._escCancelListener = null;
      }
    };

    this.onAddReactionEyes = () => {
      if (this.opts.selectmode) return;
      this.addReactionEyes();
    };

    this.dblTapAddReactionEyes = app.utils.handlers.generateDoubleTap(() => {
      this.addReactionEyes();
    });

    this.addReactionEyes = () => {
      if (this.opts.item.isMine()) return;

      this.look();
      this.opts.item.addReaction('Eyes');
    };

    this.openReactionUsersModal = async () => {
      let reactions = await this.opts.item.getUsersByReactions();
      spat.modal.open('modal-reaction-users', {reactions});
    };

    this.onDeleteMessage = async () => {
      let result =  await spat.modal.confirm('コメントを削除しますか？', '', {
        positive: '削除',
      });
      if(!result) return;

      await this.opts.item.deleteMessage();

      app.utils.openToast('deleteComment');
    };

    this.onReply = () => {
      if (!this.opts.onreplyclick) return;

      this.opts.onreplyclick(this.opts.item);
    };

    this.onQuoteReply = () => {
      if (!this.opts.onquotereply) return;
      this.opts.onquotereply(this.opts.item);
    };

    this.onEdit = async() => {
      this.isEdit = true;
      this.update();

      let form = this.refs.form;
      form.refs.editor.setValue(this.opts.item.data.content);
      form.setOption('gutters', []);
      form.focusEditor();
      form.refs.editor.setCursorToLast();

      this.addEscCancel();
      form.on('commentpost', async({value}) => {
        this.isEdit = false;

        if(this.opts.item.data.content !== value) {

          this.opts.item.updateContent(value);
        }
        this.removeEscCancel();
        this.update();
      });

      this.onCancel = () => {
        this.isEdit = false;
        this.removeEscCancel();
        this.update();
      };

      this.mentions = await this.getProject().fetchMentions();
    };

    this.onFavorite = async () => {
      await this.opts.item.favorite();
      spat.toast.message('お気に入りしました');
    };

    this.getClass = () => {

      if (this.isEdit) return;

      return this.opts.item.isMentionToMe() ? "bg-alert_pale" : "bg-white";
    };

    this.copyMarkdown = () => {
      navigator.clipboard.writeText(this.opts.item.data.content);
      spat.toast.message('コピーしました');
    };

    this.toggleCheckbox = () => {
      if (!this.opts.selectmode) return;
      const checkbox = this.refs.checkbox;
      if (checkbox) {

        checkbox.checked = !checkbox.checked;
      }
      this.trigger('messageselect');
      this.update();
    };

    this.isChecked = () => {
      const checkbox = this.refs.checkbox;
      return checkbox ? checkbox.checked : !checkbox.checked;
    };

    this.selectMode = () => {
      this.trigger('messageselect');
    };

    this.handleChange = (e) => {
      const checked = e.target.checked;
      this.opts.toggle(this.opts.item.id, checked);
    };

    this.onOpenModalReferredNote = async () => {
      let promises = [
        this.getProject().fetch(),
        this.opts.item.getNote().fetch(),
      ];
      let [project, note] = await Promise.all(promises);
      spat.modal.open('modal-referred-note', {project, note, item: this.opts.item.data.content});
    };

    this.onOpenActionSheet = async (e, isMine) => {
      let options = [
        {
          label: 'リアクション',
          icon: 'reaction',
          action: () => { this.overlay.close(); this.openReactionUsersModal(); },
        },
        {
          label: isMine ? '引用' : '引用して返信',
          icon: 'reply',
          action: () => { this.overlay.close(); this.onQuoteReply(); },
        },
        {
          label: 'お気に入り',
          icon: 'star_empty',
          action: () => { this.overlay.close(); this.onFavorite(); },
        },
        {
          label: 'コメントをコピー',
          icon: 'template',
          action: () => { this.overlay.close(); this.copyMarkdown(); },
        },
        {
          label: '選択',
          icon: 'checkbox',
          action: () => { this.overlay.close(); this.selectMode(); this.toggleCheckbox(); },
        },
        {
          label: '要約',
          icon: 'unread',
          action: () => { this.overlay.close(); this.openDifyPopup(); this.copyMarkdown(); },
        },
        {
          label: '関連ノートの作成',

          icon: 'add_circle',
          action: () => { this.overlay.close(); this.onOpenModalReferredNote(); },
        },
        {
          label: 'リマインドに追加',
          icon: 'remind',
          action: () => { this.overlay.close(); this.remind(); },
        },
        {
          label: 'メッセージを削除',
          icon: 'stash_box',
          accent: true,
          action: () => { this.overlay.close(); this.onDeleteMessage(); },
          isShow: isMine,
        },
      ];

      options = options.filter(option => option.isShow !== false);

      if (app.useragent.isMobile) {
        capacitor.hapticsImpactLight();
        this.overlay = spat.modal.open('modal-action-sheet', {
          options,
        });
      }

      else {
        this.overlay = spat.popup.open('popup-action-sheet', {
          element: this.refs.comment,
          closeTarget: this.refs.comment,
          offsetTop: 0,
          align: { x: 'right', y: 'middle'},
          position: 'bottom',
          opts: {
            options: options,
          },
        });

        await this.overlay.waitClose();
        this.overlay = null;
      }
    };

    this.look = () => {
      return this.opts.item.look();
    };

    this.getProject = () => {
      return this.opts.item.getNote().getProject();
    };

    this.onMentionClick = async ({originalEvent, screenName}) => {
      let target = originalEvent.currentTarget;
      let mention = await this.getProject().findMention(screenName);

      if (mention) {

        if (mention.type === 'user') {
          spat.popup.open('popup-user', {
            element: target,
            closeTarget: target,
            position: 'left',
            align: {y: 'top'},
            opts: {
              user: mention.item,
            },
          });
        }

        else if (mention.type === 'group') {

          if (!app.store.project) return;
          spat.popup.open('popup-group', {
            element: target,
            closeTarget: target,
            position: 'left',
            align: {y: 'top'},
            opts: {
              mention,
            },
          });
        }
      } else {
        spat.toast.message('このユーザーは存在しません。');
      }
    };

    this.remind = async () => {
      try {
        await this.opts.item.remind();
        spat.toast.message('リマインドに追加しました');
      }
      catch (e) {
        console.error(e);
      }
    };

    this.onMousemove = (e) => {
      if (this.isEdit || this.opts.selectmode || this.overlay) return;
      this.onOpenPopupMessageActions(e);
    };

    this.onMouseleave = (e) => {
      if (this.popup?.isOnMouse(e.relatedTarget)) return;
      this.popup?.close();
      this.popup = null;
    };

    this.onOpenPopupMessageActions = async (e) => {

      if (!app.useragent.isDesktop || this.popup) return;

      const comment_rect = e.currentTarget.getBoundingClientRect();
      const messages_container = this.opts.parent?.getMessagesContainer?.();
      const messages_container_top = messages_container ? messages_container.getBoundingClientRect().top : 0;
      const top_y = Math.max(comment_rect.top, messages_container_top);

      this.popup = spat.popup.open('popup-message-actions', {
        element: e.currentTarget,
        offsetTop: top_y - comment_rect.top + 10,
        align: { x: 'right'},
        position: 'top',
        opts: {
          isEdit: this.isEdit,
          isMine: this.isMine,
          onEmojiSelected: this.addReaction,
          commentElement: this.refs.comment,
        },
      });

      this.popup.on('selected', (emoji) => {
        this.onSelectReaction(emoji);
      });

      this.popup.on('close', () => {
        this.popup = null;
      });

      this.popup.on('editClick', () => {
        this.onEdit();
      });

      this.popup.on('replyClick', () => {
        this.onReply();
      });

      this.popup.on('menuClick', (e) => {
        this.onOpenActionSheet(e, this.isMine);
      });
    };

    this.onSelectReaction = async (reaction) => {
      await this.addReaction(reaction.name);
      this.trigger('submit');
    };

    this.addReaction = (key) => {
      return this.opts.item.addReaction(key, this.opts.verify);
    };

    this.on('mount', () => {
      this.refs.menu?.on('replyClick', () => {
        this.onReply();
      });

      this.refs.menu?.on('editClick', () => {
        this.onEdit();
      });

      this.refs.menu?.on('menuClick', (e) => {
        this.onOpenActionSheet(e, this.isMine);
      });
    });

    this.openDifyPopup = () => {
      this.parentElement = this.opts.parent.getElement();

      const popup = spat.popup.open('popup-dify', {
        element: this.parentElement,
        offsetTop: 0,
        position: 'top',
        opts: {
          description: 'テキストを入力して要約を作成しましょう。',
        }
      });
    };

    this.on('unmount', () => {
      this.removeEscCancel();
    });
});